/**
 * Временная заглушка покера в клиенте (переключатель лобби, экраны poker-lobby / poker-practice).
 * Установите в `false`, когда режим снова доступен игрокам.
 */
export const POKER_LOBBY_TEMP_DISABLED = true;
